import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function Modal({ isOpen, onClose, children }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-start sm:items-center justify-center p-0 sm:p-2 md:p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full sm:w-auto sm:min-w-[280px] max-w-full sm:max-w-[95vw] md:max-w-[90vw] lg:max-w-[80vw] xl:max-w-[70vw] 2xl:max-w-[60vw] transform overflow-hidden rounded-none sm:rounded-2xl bg-white text-left align-middle shadow-xl transition-all relative h-screen sm:h-auto sm:max-h-[95vh] mt-0 sm:mt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 z-30 bg-white/90 backdrop-blur-sm text-gray-500 hover:text-gray-700 hover:bg-white rounded-full p-2 sm:p-2 shadow-lg transition-all duration-200 hover:scale-110"
                  title="Kapat"
                >
                  <XMarkIcon className="h-5 w-5 sm:h-5 sm:w-5" />
                </button>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}